import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const handleClick = () => {
    // setAllLinksToInactive();
    window.scroll(0, 0);
  };

  const location = useLocation();

  if (location.pathname.startsWith("/admin")) {
    // If the route starts with '/admin', do not render the navbar
    return null;
  }

  return (
    <>
      <div className="h-[30%] bg-[#202125] w-full flex flex-col md:flex-row space-y-5 md:space-y-0 items-center justify-around p-2 md:p-8">
        <div className="flex flex-col justify-center items-center w-full md:w-1/5 h-full space-y-2">
          <img src="/Assets/logo.png" />
          <p className="font-be-jost-pro text-sm font-normal text-white opacity-60 w-auto md:w-40">
            Address : Parivahan Marg, C Scheme, Jaipur, Rajasthan 302001
          </p>
          <a href="tel: +91 7737488468"><p className="font-be-jost-pro text-sm font-normal text-white opacity-60 w-auto md:w-40">
            Phone : 7737488468
          </p></a>
          <a href="mailto: support@barbera.in"><p className="font-be-jost-pro text-sm font-normal text-white opacity-60 w-auto md:w-40">
            Email : support@barbera.in
          </p></a>
        </div>
        <div className="w-1/2 md:w-1/5 h-full flex flex-col items-center md:items-start space-y-6">
          <p className="text-white font-be-jost-pro text-sm font-medium text-center">
            Working days / Mon-Sun
          </p>
          <p className="text-white font-be-jost-pro text-sm font-medium text-center">
            Timings / 7 A.M to 7 P.M
          </p>
          {/* <p className="text-white font-be-jost-pro text-sm font-medium text-center">
            Sunday / CLOSED
          </p> */}
        </div>
        <div className="w-1/2 md:w-1/5 h-full flex flex-col items-center md:items-start space-y-6">
          <Link
            to="/career"
            className="text-white font-be-jost-pro text-sm font-medium text-center"
            onClick={handleClick}
          >
            Career
          </Link>
          <Link
            to="/terms&conditions"
            className="text-white font-be-jost-pro text-sm font-medium text-center"
            onClick={handleClick}
          >
            Terms & Conditions
          </Link>
          <Link
            to="/privacy"
            className="text-white font-be-jost-pro text-sm font-medium text-center"
            onClick={handleClick}
          >
            Privacy Policy
          </Link>
          <Link
            to="/cookie"
            className="text-white font-be-jost-pro text-sm font-medium text-center"
            onClick={handleClick}
          >
            Cookie Policy
          </Link>
        </div>

        <div className="w-1/2 md:w-1/5 h-full">
          <div className="flex flex-col w-full items-center ">
            <p className="text-white text-3xl font-normal opacity-60 text-center">
              Download App From
            </p>
            <div className="flex flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-3 mt-4">
              <button className="flex items-center justify-center w-36 bg-black rounded-md">
                <img src="/Assets/playstore.png" />
                <div className="flex flex-col p-2">
                  <p className="uppercase text-white text-[9px] font-normal font-be-vietnam-pro">
                    {" "}
                    get it on{" "}
                  </p>
                  <p className="text-white text-sm font-medium font-be-vietnam-pro tracking-wider">
                    Google Play
                  </p>
                </div>
              </button>
              <button className="flex items-center justify-center w-36 bg-black rounded-md">
                <img src="/Assets/apple.png" />
                <div className="flex flex-col p-2">
                  <p className=" text-white text-[9px] font-normal font-be-vietnam-pro">
                    Download on the
                  </p>
                  <p className="text-white text-sm font-medium font-be-vietnam-pro tracking-widest">
                    App Store
                  </p>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="h-[10%] bg-[#11120F] w-full flex flex-col md:flex-row space-y-3 md:space-y-0 py-2 justify-between px-12 items-center">
        <p className="text-white font-be-jost-pro text-base font-medium text-center">
          © 2023 Barbera. All rights reserved. Developed by{" "}
          <b>Jethi Tech Solutions</b>
        </p>
        <div className="flex space-x-3">
          <a target="_blank" href="https://instagram.com/barbera_home_salon_?igshid=YmM0MjE2YWMzOA=="><img src="/Assets/instagram.png" /></a>
          <a target="_blank" href="https://www.facebook.com/BarberaSalonAtYourHome/"><img src="/Assets/facebook.png" /></a>
          {/* <a target="_blank" href=""><img src="/Assets/twitter.png" /></a> */}
          <a target="_blank" href="https://www.linkedin.com/in/sumit-kumawat-837677183/"><img src="/Assets/linkedin.png" /></a>
        </div>
      </div>
    </>
  );
};

export default Footer;
